import watchGetVideoRequested from './getVideoSaga';

export default [
  watchGetVideoRequested(),
];
